import {
  BRANDFETCH_API_KEY,
  BRANDFETCH_BASE_URL,
  PERSONAL_EMAIL_DOMAINS,
  TEST_USER_EMAILS,
} from './consts'

export const extractDomainFromEmail = (email: string): string | null => {
  const parts = email.split('@')
  if (parts.length !== 2) return null
  return parts[1].toLowerCase()
}

export const isWorkEmail = (email: string): boolean => {
  const normalized = email.trim().toLowerCase()
  if (TEST_USER_EMAILS.includes(normalized)) return true
  const domain = extractDomainFromEmail(normalized)
  if (!domain) return false
  return !PERSONAL_EMAIL_DOMAINS.includes(domain)
}

export const generateBrandfetchUrls = (companyUrl: string): string[] => {
  if (!companyUrl) return []
  return [
    `${BRANDFETCH_BASE_URL}/${companyUrl}/fallback/404/w/400?c=${BRANDFETCH_API_KEY}`,
    `${BRANDFETCH_BASE_URL}/${companyUrl}/fallback/404/w/400/logo?c=${BRANDFETCH_API_KEY}`,
    `${BRANDFETCH_BASE_URL}/${companyUrl}/fallback/404/w/400/theme/light/logo?c=${BRANDFETCH_API_KEY}`,
    `${BRANDFETCH_BASE_URL}/${companyUrl}/fallback/404/w/400/symbol?c=${BRANDFETCH_API_KEY}`,
    `${BRANDFETCH_BASE_URL}/${companyUrl}/fallback/404/w/400/theme/light/symbol?c=${BRANDFETCH_API_KEY}`,
  ]
}

export const isValidCompanyUrl = (url: string): boolean => {
  if (!url || !url.includes('.')) return false
  const parts = url.split('.')
  return parts[1]?.length > 1
}

export const extractRootDomainName = (domain: string): string => {
  if (!domain) return ''
  
  // Remove protocol, www, and trailing slashes
  const cleaned = domain
    .replace(/^https?:\/\//, '')
    .replace(/^www\./, '')
    .replace(/\/$/, '')
  
  // Extract root domain (e.g., "lemlist.com" -> "lemlist")
  const parts = cleaned.split('.')
  const rootDomain = parts[0] || cleaned
  
  // Capitalize first letter
  return rootDomain.charAt(0).toUpperCase() + rootDomain.slice(1).toLowerCase()
}

export const namesFromAuthMetadata = (
  metadata: Record<string, unknown> | undefined,
  email: string
): { firstName: string; lastName: string } => {
  const given = String(metadata?.given_name || metadata?.first_name || '').trim()
  const family = String(metadata?.family_name || metadata?.last_name || '').trim()
  if (given) return { firstName: given, lastName: family }

  const full = String(metadata?.full_name || metadata?.name || '').trim()
  if (full) {
    const [first, ...rest] = full.split(/\s+/)
    return { firstName: first || '', lastName: rest.join(' ') }
  }

  const local = email.split('@')[0] || ''
  const firstName =
    local.charAt(0).toUpperCase() + local.slice(1).toLowerCase()
  return { firstName, lastName: '' }
}

export const isIdentityAlreadyLinkedError = (error: {
  code?: string
  message?: string
}) => {
  if (error.code === 'identity_already_exists') return true
  return /already (been )?linked|already exists|identity is already/i.test(
    error.message || ''
  )
}

export const isEmailAlreadyRegisteredError = (error: {
  code?: string
  message?: string
}) => {
  if (error.code === 'email_exists' || error.code === 'user_already_exists') {
    return true
  }
  return /already (been )?registered|email address has already been|user already registered/i.test(
    error.message || ''
  )
}
